(() => {
  const media = matchMedia('(max-width: 749px)');

  const sync = (root = document) => {
    root.querySelectorAll('.alvento-footer-accordion').forEach((button) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = media.matches && button.getAttribute('aria-expanded') !== 'true';
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('footer .footer-content').forEach((footer) => {
      [...footer.children].slice(1, 4).forEach((group, index) => {
        if (group.dataset.mobileAccordion) return;
        const heading = group.querySelector('h3');
        if (!heading) return;

        let headingBlock = heading;
        while (headingBlock.parentElement && headingBlock.parentElement !== group) headingBlock = headingBlock.parentElement;
        if (headingBlock.parentElement !== group) return;

        const panel = document.createElement('div');
        const panelId = `alvento-footer-panel-${index}-${Math.random().toString(36).slice(2, 8)}`;
        panel.id = panelId;
        panel.className = 'alvento-footer-mobile-panel';

        let sibling = headingBlock.nextElementSibling;
        while (sibling) {
          const next = sibling.nextElementSibling;
          panel.append(sibling);
          sibling = next;
        }

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'alvento-footer-accordion';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', panelId);
        button.innerHTML = `<span role="heading" aria-level="3">${heading.textContent.trim()}</span><span aria-hidden="true">+</span>`;
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          panel.hidden = expanded;
        });

        headingBlock.classList.add('alvento-footer-desktop-heading');
        group.insertBefore(button, headingBlock);
        group.append(panel);
        group.dataset.mobileAccordion = 'true';
      });
    });
    sync(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  media.addEventListener?.('change', () => sync());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
